export function get_location() {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(show_position, error_position);
    } else {
        document.getElementById('location').innerHTML = 'Геолокация не поддерживается.';
    }
}

export function cookie_has_city() {
    return jQuery.cookie('user_city') ?? '';
}

export function set_city_in_cookie(e) {
    const city = e.target?.dataset?.setCityInCookie ?? '';
    const base_domain = get_base_domain();

    jQuery.cookie('user_city', city, {
        expires: 365,
        path: '/',
        domain: '.' + base_domain
    });
}

function get_base_domain() {
    const host_data = location.host.split('.') ?? [];
    let base_domain = host_data[host_data.length - 1] ?? 'is-telecom.ru';

    if (base_domain.length <= 3) {
        base_domain = `${host_data[host_data.length - 2] ?? ''}.${base_domain}`;
    }

    return base_domain;
}

function show_position(obj) {
    const modal = jQuery('[data-dialog="cities-definition"]');
    const city_name_block = modal.find('[data-current-city-name]');
    const city_slug_block = modal.find('[data-set-city-in-cookie]');

    const { latitude = '', longitude = '' } = obj?.coords ?? {};

    jQuery.ajax('/wp-admin/admin-ajax.php', {
        method: 'POST',
        data: {
            action: 'get_city_by_coords',
            latitude,
            longitude
        },
        success(data) {
            const { name = '', slug = '' } = data;
            if (name && slug) {
                city_name_block.html(name);
                city_slug_block.attr('data-set-city-in-cookie', slug);
                city_slug_block.attr('href', create_new_url_from_subdomain(slug));
            }
        }
    });
}

export function show_modal() {
    const block = jQuery('[data-dialog="cities-definition"]');
    if (!jQuery.cookie('user_city')) {
        block.delay(2000).show('500');
        let timeout = setTimeout(() => {
            jQuery(block).hide('500');
        }, 20000);

        block.mouseenter(() => {
            clearInterval(timeout);
        });

        block.on('click', '[data-dialog-close]', () => {
            jQuery(block).hide('200');
        });
    }
}

function error_position(params) {
    console.error(params);
}

function create_new_url_from_subdomain(subdomain) {
    subdomain = subdomain !== 'aminevo' ? subdomain + '.' : '';
    const host = `${subdomain}${get_base_domain()}`;
    const url = new URL(location.href);
    url.host = host;
    return url.href;
}
